import { useNavigate } from "react-router-dom";

import { useThemeContext } from "../../context/ThemeContext";
import { TOKENS } from "../../hooks/useTheme";

import { Breadcrumb } from "../../components/Breadcrumb/Breadcrumb";
import { Shape } from "../../components/Shape/Shape";
import { Card } from "../../components/Card/Card";
import { Button } from "../../components/Button/Button";

export function NotFound() {
  const theme = useThemeContext();
  const navigate = useNavigate();

  return (
    <section
      style={{
        padding: "90px 0 60px",
        minHeight: "52vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Breadcrumb
        theme={theme}
        breadcrumbs={[
          ["home", "home"],
          ["404", "not found"],
        ]}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 18,
          marginBottom: 18,
        }}
      >
        <Shape kind="blob" color={theme.acc} size={40} />
        <span
          style={{
            fontSize: 10,
            color: theme.muted,
            textTransform: "uppercase",
            letterSpacing: "0.16em",
            padding: "4px 10px",
            border: `1px solid ${theme.rule}`,
            borderRadius: 999,
          }}
        >
          error · 404
        </span>
      </div>

      <h1
        style={{
          color: theme.fg,
          display: "flex",
          alignItems: "baseline",
          gap: 18,
          flexWrap: "wrap",
        }}
      >
        <span>404</span>
        <span
          style={{
            fontSize: "clamp(20px, 2.6vw, 28px)",
            fontWeight: 400,
            color: theme.muted,
            letterSpacing: 0,
          }}
        >
          page not found
        </span>
      </h1>

      <Card theme={theme} style={{ maxWidth: 620, marginTop: 6 }}>
        <div
          style={{
            fontSize: 10,
            color: theme.muted,
            letterSpacing: "0.14em",
            marginBottom: 10,
          }}
        >
          ✦ 404.TS
        </div>
        <pre
          style={{
            margin: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 12.5,
            lineHeight: 1.75,
            color: theme.fg,
            whiteSpace: "pre-wrap",
          }}
        >
          <span style={{ color: TOKENS.comment }}>
            {"// this route doesn't exist (yet)."}
          </span>
          {"\n"}
          <span style={{ color: theme.acc }}>const</span>{" "}
          <span style={{ color: TOKENS.fn }}>page</span> ={" "}
          <span style={{ color: theme.acc }}>await</span> find(
          <span style={{ color: TOKENS.kw }}>location.hash</span>);{"\n"}
          <span style={{ color: theme.acc }}>if</span> (!page) {"{"}
          {"\n"}
          {"  "}
          <span style={{ color: theme.acc }}>throw</span>{" "}
          <span style={{ color: theme.acc }}>new</span> NotFound(
          <span style={{ color: TOKENS.kw }}>'nothing here, sorry'</span>);
          {"\n"}
          {"}"}
        </pre>
      </Card>

      <p
        style={{
          margin: "22px 0 26px",
          fontSize: 14.5,
          color: theme.muted,
          lineHeight: 1.7,
          maxWidth: 560,
        }}
      >
        Whatever you were looking for, it isn't at this address. Maybe it moved,
        maybe it was never here, maybe I broke a link somewhere — it happens.
      </p>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <Button
          buttonType="primary"
          buttonText="← back to home"
          onClick={() => navigate("/")}
        />
      </div>
    </section>
  );
}
